/* eslint-disable */
import ytPlayer from "../modules/ytPlayer";

export default el => {
    ytPlayer(document.querySelector(".ytPlayer"));
}